export default __webpack_public_path__ + "static/banner-grey-circle-6326f8953e60aff3f4af88a08255ec40.png";